import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Card,
  styled,
  Typography,
  TextField,
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import SearchIcon from '@mui/icons-material/Search';

interface FilterSectionProps {
  typeFilter: string;
  productTagFilter: string;
  searchQuery: string;
  filteredCount: number;
  totalCount: number;
  typeOptions: string[];
  teamOptions: string[];
  onTypeFilterChange: (value: string) => void;
  onProductTagFilterChange: (value: string) => void;
  onSearchChange: (value: string) => void;
}

const StyledFilterCard = styled(Card)(() => ({
  background: 'white',
  boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08)',
  borderRadius: 16,
  border: '1px solid #e0e0e0',
  marginBottom: 24,
  padding: 20,
  maxWidth: 'fit-content',
  margin: '0 auto 24px auto',
}));

const StyledSelect = styled(Select)(() => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: 8,
    backgroundColor: 'white',
  },
}));

export const FilterSection: React.FC<FilterSectionProps> = ({
  typeFilter,
  productTagFilter,
  searchQuery,
  filteredCount,
  totalCount,
  typeOptions,
  teamOptions,
  onTypeFilterChange,
  onProductTagFilterChange,
  onSearchChange,
}) => {
  return (
    <StyledFilterCard>
      <Box
        sx={{ display: 'flex', gap: 3, alignItems: 'center', flexWrap: 'wrap' }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            color: '#1976d2',
          }}
        >
          <FilterListIcon fontSize="small" />
        </Box>
        <TextField
          size="small"
          placeholder="Search..."
          value={searchQuery}
          onChange={e => onSearchChange(e.target.value)}
          InputProps={{
            startAdornment: (
              <SearchIcon sx={{ mr: 1, color: 'text.secondary' }} />
            ),
          }}
          sx={{ minWidth: 250 }}
        />
        <FormControl size="small" sx={{ minWidth: 150 }}>
          <InputLabel sx={{ fontWeight: 500 }}>Type</InputLabel>
          <StyledSelect
            value={typeFilter}
            label="Type"
            onChange={e => onTypeFilterChange(e.target.value as string)}
          >
            <MenuItem value="">All</MenuItem>
            {typeOptions.map(t => (
              <MenuItem key={t} value={t.toLowerCase()}>{t}</MenuItem>
            ))}
          </StyledSelect>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 150 }}>
          <InputLabel sx={{ fontWeight: 500 }}>Team</InputLabel>
          <StyledSelect
            value={productTagFilter}
            label="Team"
            onChange={e => onProductTagFilterChange(e.target.value as string)}
          >
            <MenuItem value="">All</MenuItem>
            {teamOptions.map(t => (
              <MenuItem key={t} value={t}>{t}</MenuItem>
            ))}

          </StyledSelect>
        </FormControl>
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{ fontWeight: 500, ml: 2 }}
        >
          Showing {filteredCount} of {totalCount}
        </Typography>
      </Box>
    </StyledFilterCard>
  );
};
